import React, { useContext, useEffect, useState } from "react";
import { Fragment } from 'react';
import TopArroow from "../../../../resources/console/images/icon/top_arrow.svg";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../components/AppProvider";
import useStore from "../../../../modules/utils/store";
export const Footer = (props) => {
  const { auth, iam } = useContext(AppContext);
  const { siteInfo } = useStore();
  const { footerClass, eventInfo } = props;
  const [termsInfo, setTermsInfo] = useState(null);
  const [openModal, setOpenModal] = useState(null); 
  const showTerms = (type, e) => {
    if (e) e.preventDefault();
    $("body").css("overflow", "hidden");
    if (type === "termsUseAgree")
      setTermsInfo({ title: "Site Terms of Use", content: siteInfo?.memTermsUseForm });
    else if (type === "termsPrivateAgree")
      setTermsInfo({
        title: "Privacy policy",
        content: siteInfo?.memTermsPrivacyForm,
      });
    else if (type === "termsMarket")
      setTermsInfo({
        title: "Consent to receive marketing information",
        content: siteInfo?.memTermsMarketForm,
      });
    else {
      setTermsInfo(null);
    }
  };

  const modalClose = () => {
    setTermsInfo(null);
    setOpenModal(false);
    $("body").css("overflow", "auto");
  };

  const linkRel = () => { 
    window.open("https://nedrug.mfds.go.kr/pbp/CCBBB01/getItemDetail?itemSeq=201601746")
  }
  
  useEffect(() => {
    const openModalHandler = function (e) {
      e.preventDefault();
      $("body").css("overflow", "hidden");
      setOpenModal(true);
    };
    $("#openModal").click(openModalHandler);
    return () => {
      $("#openModal").off("click", openModalHandler);
    };
  }, []);
  return (
    <footer id="footer">
      <div className="footer-arrow-wrap">
        <button type="button" className="go-to-top">
            <img src={TopArroow} alt="Top Button" />
            <span>TOP</span>
        </button>
      </div>
      {!['MEDIGATE','ICOD','GSK'].includes(iam?.targetType) && (<>
      <div className="footer_inform_cont">
        <div className="wid_1180">
          <ul>
            {siteInfo?.subPageList.map((item, i) => {
              return(
                <React.Fragment key={`footer_subpage_${i}_${item.pageId || item.name}`}>
                {item.isShortcutShow == 1 && (
                  item.pageType == "LINK" ? (
                    <li>
                      <a href={`https://${item.link}`} className="link" target={item.openType == "POPUP" ? "_blank" : ""} >
                        <span>{item?.name}</span>
                      </a>
                    </li>
                  ) : (
                    <li>
                      <a href={`/#/site/${siteInfo.idx}/subpage/${item.pageId}`} className="link" target={item.openType == "POPUP" ? "_blank" : ""} >
                        <span>{item?.name}</span>
                      </a> 
                    </li>
                  )
                )}
                </React.Fragment>
              )
            })}
          </ul>
        </div>
      </div>
      </>)}
      <div className="footer">
        <div className="wid_1180">
          <pre className="ft_info">
            <div dangerouslySetInnerHTML={{ __html: siteInfo?.footer?.replace(/\n/g,'') }} />
          </pre>
          {iam?.targetType == "MEMBER" && siteInfo?.memberFooterCheck === "Y" ? (
            <div className="ft_info2" style={{ marginTop: "30px" }}>
              <a onClick={showTerms.bind(this, "termsPrivateAgree")}>Privacy policy.</a>
              <a onClick={showTerms.bind(this, "termsUseAgree")}>Site Terms of Use</a>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {termsInfo && (
        <Fragment>
          <div className="ft_modal_container">
            <div className="ft_modal_header">
              <div>
                <h2>{termsInfo?.title}</h2>
                <button
                  className="close_btn"
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    modalClose();
                  }}
                  >
                  <img src="https://cdn.onoffevent.com/common/icon_close.svg" />
                </button>
              </div>
            </div>
            <div className="ft_modal_content">
              <div dangerouslySetInnerHTML={{ __html: termsInfo?.content }} />
            </div>
          </div>
          <div className="modal_bg on"></div>
      </Fragment>
      )}
      {openModal && (
        <div className="modal_container">
          <button className="modal_close" onClick={modalClose}><img src="https://cdn.onoffevent.com/common/icon_close.svg" alt="닫기"/></button>
          <div className="modal_mid">
            <h4>
              You are attempting to navigate to a different page on the GSK Korea website.<br/>
              By clicking this link, you will be redirected to a different website or web channel.
            </h4>
            <span>
              The page you are about to access may be a related site of GSK Korea, a global GSK site, or an affiliate site where Korean regulations may not apply.
              If you are redirected to a third-party site that is not managed or owned by GSK, GSK is not responsible for the content provided on that site.
            </span>
          </div>
          <div className="btnBox">
            <button className="modalBtn cancelBtn" onClick={modalClose}>Cancle</button>
            <button className="modalBtn confirmBtn" onClick={linkRel}>Continue</button>
          </div>
        </div>
      )}
    </footer>
  );
};
